export default "__VITE_ASSET__FYG$0ptr__"